import * as React from 'react';

import { Grid,  Button } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { MuiThemeProvider } from '@material-ui/core/styles';

import { Trans, TransProps, WithTranslation, withTranslation } from 'react-i18next';

import { window2config } from '../../cfg/config';
import CONFIG from '../../cfg/config';

import { List, ListItem, Typography, ListItemText, ListItemIcon } from '@material-ui/core';
import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { hotelService, webHotel, PortalInfo, Info, webRooms, roomsService, webRoom, passService, Bramka, Result, resetService, KarnetService, KarnetZjazdy } from '../../api';
import { ClassNameMap } from '@material-ui/styles';
import theme from '../../themes';
import TabelaZjazdy from './TabelaZjazdy';
import DialogZdjecie from './DialogZdjecie';

import zdjecie1 from './../../zdjecia/1.jpg'
import zdjecie2 from './../../zdjecia/2.jpg'
import zdjecie3 from './../../zdjecia/3.jpg'
import { NoResult } from 'components/NoResult';
import Pagination, { calculateRange } from 'components/Pagination';
import LoaderNoWindow from 'components/LoaderNoWindow';
import { sendErrorLog } from 'common/helpers';

interface DoladujKarnetProps {
  page: IPageState,
}

interface DoladujKarnetState {
  paginacja: number[],
  loading: boolean,

  openZdjecia: boolean,
  zjazd: KarnetZjazdy,
  zdjecie: any,
}

class DoladujKarnet extends React.Component<DoladujKarnetProps & WithTranslation & TransProps & WithStyles<typeof styles>, DoladujKarnetState> {

  constructor(props: DoladujKarnetProps & WithTranslation & WithStyles<typeof styles>) {
    super(props, {});
    window2config();
   
    this.state = {
      paginacja: [0, 1, 10],
      loading: false,

      openZdjecia: false,
      zjazd: new KarnetZjazdy(),
      zdjecie: {}
    }
  }

  componentDidMount() {
    sendErrorLog("1", "1", 'historia zjazdow')
    this.getTabela()
  }

  componentDidUpdate(prevProps: DoladujKarnetProps) {
    if (prevProps.page.refresh !== this.props.page.refresh) {
      this.getTabela()
    }
   
  }

  getTabela = async () => {
    try {
      this.setState({loading: true})
      let res: Result<KarnetZjazdy> = await KarnetService.dajKarnetZjazdy({ parametry: { hotelId: CONFIG.hotelId, operatorId: "1", karnetEkarta: this.props.page.karnet.ekarta } })
      
      //res.result[0].dt = "2024-11-04 12:34:28"
      //res.result[1].dt = "2024-11-03 12:34:28"

      store.dispatch(Actions.pageState.setKarnetZjazdy(res.result))
      this.setState({loading: false})
      //console.log(res)
    } catch (error) {
      console.error()
      sendErrorLog("0", "-1", '/karnet/dajKarnetZjazdy')
      store.dispatch(Actions.pageState.addFcmLogMessage("/karnet/dajKarnetZjazdy", 2))
    }

  //   let tabela = [
  //     {
  //         data: "2024-11-19 09:20",
  //         opis: "taśma",
  //     },
  //     {
  //         data: "2024-11-19 09:35",
  //         opis: "taśma",
  //     },
  //     {
  //         data: "2024-11-19 09:50",
  //         opis: "taśma",
  //     },
  //     {
  //         data: "2024-11-19 10:10",
  //         opis: "lewy orczyk",
  //     },
  //     {
  //         data: "2024-11-19 10:30",
  //         opis: "prawy orczyk",
  //     }, 
  //     {
  //         data: "2024-11-19 10:45",
  //         opis: "prawy orczyk",
  //     },
  //     {
  //         data: "2024-11-19 11:01",
  //         opis: "prawy orczyk",
  //     }, 
  //     {
  //         data: "2024-11-19 09:20",
  //         opis: "taśma",
  //     },
  //     {
  //         data: "2024-11-19 09:35",
  //         opis: "taśma",
  //     },
  //     {
  //         data: "2024-11-19 09:50",
  //         opis: "taśma",
  //     },
  //     {
  //         data: "2024-11-19 10:10",
  //         opis: "lewy orczyk",
  //     },
  //     {
  //         data: "2024-11-19 10:30",
  //         opis: "prawy orczyk",
  //     }, 
  //     {
  //         data: "2024-11-19 10:45",
  //         opis: "prawy orczyk",
  //     },
  //     {
  //         data: "2024-11-19 11:01",
  //         opis: "prawy orczyk",
  //     },
  // ]

  // this.setState({tabela: tabela})
  }

  updateSkip = async (aPage: number) => {
    const newSkip = (aPage - 1) * this.state.paginacja[2]
    this.setState({ paginacja: [newSkip, aPage, this.state.paginacja[2]] })
  }
  changeRowsPerPage = async (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
    this.setState({ paginacja: [0, 1, Number(event.target.value)] })
  }

  select = (data: KarnetZjazdy) => {
    let zdjecie: any = {}
    switch (data.akcjaCzytnikOpis) {
      case "tasma":
        zdjecie = zdjecie1
        break;
      case "orczyk lewy":
        zdjecie = zdjecie2
        break;
      case "orczyk prawy":
        zdjecie = zdjecie3
        break;

      default:
        break;
    }

    this.setState({zjazd: data, openZdjecia: true, zdjecie})
  } 
  
  closeZdjecie = () => {
    this.setState({openZdjecia: false})
  }

  render() {
    const { classes, t } = this.props;

    let ilosc = this.props.page.karnetZjazdy.length
    const range = calculateRange(ilosc, this.state.paginacja[2])
    
    let tabela: KarnetZjazdy[] = this.props.page.karnetZjazdy;
    tabela = tabela.slice(this.state.paginacja[0], this.state.paginacja[0] + this.state.paginacja[2]) 
    let tablet = this.props.page.tablet

      return (
          <Grid container spacing={2} className={classes.container1} justify="center" alignItems="center"  >
              <Grid item xs={12} sm={12} className={classes.gridItem} style={{maxWidth: tablet ? "450px" : "370px", margin: "auto", paddingLeft: 0, paddingRight: 0}}>
                 
            { this.state.loading? 
              <LoaderNoWindow/> :
              tabela.length === 0 ?
                <NoResult text={'Czekamy na Twoje zjazdy'}/> :
                <>
                  <TabelaZjazdy
                    tableBody={tabela}
                    icon
                    select={this.select}
                  />

                  <Pagination
                    page={this.state.paginacja[1]}
                    range={range}
                    updateSkip={this.updateSkip}
                    changeResultsPerPage={this.changeRowsPerPage}
                    resultsPerPage={this.state.paginacja[2]}
                    tableLength={ilosc}
                  />


                </>}

                  <DialogZdjecie open={this.state.openZdjecia} closeDialog={this.closeZdjecie} zdjecie={this.state.zdjecie} tytul={this.state.zjazd.dt}/>


              </Grid>
          </Grid>
      );
  }
}

const styles = (theme: Theme) => ({
    container1: {
        //margin: "0em",
        //paddingTop: "0.4em",
        margin: "12px auto 0px",
        padding: '0em 0em',
        minHeight: "100%",
        maxWidth: "1340px",
        //border: "2px solid lavender"
      },
      gridItem: {
        minHeight: "150px",
      },
      
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DoladujKarnet))); 

